export default {
	auth: {
		nonIntegratedIdentity: null,
		integratedIdentity: null,
		accounts: null,
	},

	eventId: null,
	event: null,
	isBadEvent: false,

	me: null,

	workspace: null,

	accountRetrieval: null,
	loginSubmission: null,
	registrationSubmission: null,
	hadSubmissionError: false,

	fields: [
		makeField('firstName', 'First Name', { required: true, aliases: ['First'] }),
		makeField('lastName', 'Last Name', { required: true, aliases: ['Last'] }),
		makeField('email', 'Email', { required: true, aliases: ['Email Address'] }),
		makeField('gradYear', 'Grad Yr', { required: true, aliases: ['Grad Year', 'Class Year', 'Class Yr'] }),
		makeField('jerseyNumber', 'Jersey Number', { required: true, aliases: ['Jersey', 'Jersey No', 'Jersey No'] }),
		makeField('positions', 'Position', { aliases: ['Positions'] }),
        makeField('guardianEmail1', 'Guardian Email 1', { aliases: ['Parent Email 1'] }),
        makeField('guardianEmail2', 'Guardian Email 2', { aliases: ['Parent Email 2'] }),
        makeField('phoneNumber', 'Phone Number', { aliases: ['Phone'] }),
        makeField('preCommitted', 'Committed', { aliases: ['Pre-Committed'] }),
	],
}

function makeField(name, label, { required = false, aliases = [] } = {}) {
    return { name, label, required, aliases }
}